import { NewModal } from 'lib/components';
import React from 'react';
import { ILandingPageDesignGroup, ILandingPageDesignResponse } from '../types';
import { Flex, Gap } from 'lib/components/styles/layout';
import { Button } from 'react-covideo-common';
import { useRemoveBatchFromGroupMutation } from 'lib/api/superadmin/landingPageDesignGroups/useRemoveBatchFromGroupMutation';

type RemoveFromGroupModalProps = {
  handleCloseModal: () => void;
  group: ILandingPageDesignGroup;
  setSelectedLandingPageDesigns: React.Dispatch<
    React.SetStateAction<ILandingPageDesignResponse[]>
  >;
  selectedLandingPageDesigns: ILandingPageDesignResponse[];
};

const RemoveFromGroupModal = ({
  handleCloseModal,
  selectedLandingPageDesigns,
  setSelectedLandingPageDesigns,
  group,
}: RemoveFromGroupModalProps) => {
  const { mutateAsync: removeBatchFromGroup, isLoading: isRemoving } =
    useRemoveBatchFromGroupMutation({
      groupId: group.landingPageDesignGroupId,
      landingPageDesigns: selectedLandingPageDesigns.map(
        lpDesign => lpDesign.id
      ),
    });

  const isSingular = selectedLandingPageDesigns.length === 1;
  const singularTitle = `Are you sure you want to remove "${selectedLandingPageDesigns[0].title}" Landing Page from ${group.title}?`;
  const pluralTitle = `Are you sure you want to remove ${selectedLandingPageDesigns.length} Landing Pages from ${group.title}?`;
  const removeMessage = `${isSingular ? 'This' : 'These'} landing page${isSingular ? '' : 's'} will be removed from ${group.title}.`;

  const handleRemove = async () => {
    await removeBatchFromGroup();
    setSelectedLandingPageDesigns([]);
    handleCloseModal();
  };
  return (
    <NewModal
      closeModal={handleCloseModal}
      headerText={isSingular ? singularTitle : pluralTitle}
    >
      <Flex gap='20px'>
        <div>{removeMessage}</div>
        <Gap gap='8px' justifyContent='flex-end'>
          <Button
            text='Cancel'
            variant='secondary'
            disabled={isRemoving}
            onClick={handleCloseModal}
          />
          <Button
            text='Remove'
            variant='destructive'
            onClick={handleRemove}
            disabled={isRemoving}
            loading={isRemoving}
          />
        </Gap>
      </Flex>
    </NewModal>
  );
};

export default RemoveFromGroupModal;
